import axios from "../axios";

const createWithdrawal = async function (accessToken,data = {}) {
    try {
        const response = await axios.post('withdraw/createWithdrawal', data ,{
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default createWithdrawal;
